import map from 'lodash/map';
import find from 'lodash/find';
import filter from 'lodash/filter';
import startsWith from 'lodash/startsWith';
import includes from 'lodash/includes';

import {
    getSearchFieldsByServiceArea, getRDSearchFieldsByServiceArea, LOGIC_FIELDS, DEFAULT_FIELDS,
} from '../config';
import { SECTION_TYPE_FIELD, SECTION_TYPE_LOGIC } from '../../constants';

export const getDefaultSuggestions = (isRDVersion = false) => {
    const SEARCH_FIELDS = isRDVersion ? getRDSearchFieldsByServiceArea() : getSearchFieldsByServiceArea();
    const suggestion = map(DEFAULT_FIELDS.other, (fieldName) => {
        const obj = find(SEARCH_FIELDS, ({ name }) => name === fieldName);
        return obj || {};
    });
    return {
    // FIXME: 提高给 SuggestionBoard，用于判断是否为默认模式. 这种实现方式不理想
        isDefault: true,
        content: suggestion,
        section: SECTION_TYPE_FIELD,
    };
};

export const findFieldSuggestionsByStem = (stem/* uppercase  required */, isRDVersion = false) => {
    let content = [];
    const SEARCH_FIELDS = isRDVersion ? getRDSearchFieldsByServiceArea() : getSearchFieldsByServiceArea();
    if (stem) {
        // eslint-disable-next-line no-use-before-define
        let stemReg = _escape(stem);
        stemReg = new RegExp(`\\b${stemReg}`, 'i');
        content = filter(SEARCH_FIELDS, ({
            name, desc,
        }) => startsWith(name, stem)
        // || includes(name, stem)
        || stemReg.test(desc.en)
        || includes(desc.cn, stem)
        || includes(desc.tw, stem)
        || includes(desc.jp, stem));
    } else {
        content = filter(SEARCH_FIELDS, ({ name }) => includes(DEFAULT_FIELDS.default, name));
    }
    if (content.length === 0) return;
    if (content.length > 5) {
        content = content.slice(0, 5);
    }
    // eslint-disable-next-line consistent-return
    return {
        section: SECTION_TYPE_FIELD,
        content,
    };
};

export const getLogicSuggestions = () => ({
    section: SECTION_TYPE_LOGIC,
    content: LOGIC_FIELDS,
});

// eslint-disable-next-line no-underscore-dangle
function _escape(str) {
    return str.replace(/[()/.*+?^$|\\[\]]/g, '\\$&');
}
